export const animationDurationMs = 300;
export const baseAnimationDelayMs = 800;
export const runningAnimationDelayMs = 500;

export const baseAnimationDelay = `${baseAnimationDelayMs}ms`;
export const runningAnimationDelay = `${runningAnimationDelayMs}ms`;
export const animationDuration = `${animationDurationMs}ms`;
